import { BACKORDERS as T, PRODUCT_CATALOG_VISIBILITIES as n, PRODUCT_DATE_FIELDS as S, PRODUCT_STOCK_STATUS as s, PRODUCT_TYPES as u, getIsVariation as a, getProductFilterLabels as O, isSubscription as D, isVariable as R, isVariation as _, productKeyLabelMapper as p } from "./product.js";
import { ORDER_STATUS as I, getOrderStatus as c } from "./order.js";
function t(r) {
  return ["yes", "1", 1, "true", "on"].includes(r) || r === !0;
}
function o(r) {
  return t(r) ? "yes" : "no";
}
export {
  T as BACKORDERS,
  I as ORDER_STATUS,
  n as PRODUCT_CATALOG_VISIBILITIES,
  S as PRODUCT_DATE_FIELDS,
  s as PRODUCT_STOCK_STATUS,
  u as PRODUCT_TYPES,
  o as boolToString,
  a as getIsVariation,
  c as getOrderStatus,
  O as getProductFilterLabels,
  D as isSubscription,
  R as isVariable,
  _ as isVariation,
  p as productKeyLabelMapper,
  t as stringToBool
};
